



























import Vue from 'vue'
import { FileServiceProxy,RenameDto } from '@/service-proxies/app-v2/dnc.service-proxies'
const fileservice = new FileServiceProxy()
export default Vue.extend ({
  props: {
    record:{
      type: Object,
      default: () => ({})
    },
    parentid:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: this.record.name,
      editable:false,
      canEdit: false
    };
  },
  computed:{
    icon(){
      let icon = 'file-unknown'
      if(this.record.contentType === undefined){
        icon = 'folder-open'
      } else if( this.record.contentType && this.record.contentType.indexOf('image/') !== -1) {
        icon = 'file-image'
      } else {
        icon = 'file-text'
      }
      return icon
    },
    color(){
      let color = '#52c41a'
      if(this.record.contentType === undefined){
        color = '#ffe17b'
      } else if( this.record.contentType && this.record.contentType.indexOf('image/') !== -1 ) {
        color = '#71ce52'
      } else {
        color = '#92a8c1'
      }
      return color
    }
  },
  methods: {
    handleChange(e) {
      this.value = e.target.value;
    },
    clickEdit() {
      this.editable = true;
    },
    edit() {
      this.canEdit = !this.canEdit;
    },
    check() {
      const values = new RenameDto({
        fileType: (this.record.contentType === undefined) ? 1 : 2,
        newName: this.value,
        parentId: this.parentid
      })
      fileservice.rename(this.record.id,values).then(res =>{
        this.editable = false;
        this.$emit('change', true);
      })
    },
  },
})
